export default function KartRacerIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#5DBB4C" />
      <path d="M-4 46 C 18 30, 40 58, 70 34" fill="none" stroke="#FFFFFF" strokeWidth="22" />
      <path d="M-4 46 C 18 30, 40 58, 70 34" fill="none" stroke="#5B5E68" strokeWidth="17" />
      <path d="M-4 46 C 18 30, 40 58, 70 34" fill="none" stroke="#FFFFFF" strokeWidth="1.5" strokeDasharray="5 5" />
      <g transform="translate(30 40) rotate(-12)">
        <rect x="-15" y="-13" width="8" height="6" rx="1.5" fill="#1B1D22" />
        <rect x="-15" y="7" width="8" height="6" rx="1.5" fill="#1B1D22" />
        <rect x="7" y="-12" width="7" height="5" rx="1.5" fill="#1B1D22" />
        <rect x="7" y="7" width="7" height="5" rx="1.5" fill="#1B1D22" />
        <path d="M-15 -8 H12 Q19 0 12 8 H-15 Z" fill="#2F8BFF" stroke="#164787" strokeWidth="2" />
        <circle cx="-3" cy="0" r="6" fill="#FFFFFF" stroke="#164787" strokeWidth="1.5" />
        <path d="M-22 -4 L-30 0 L-22 4 Z" fill="#FF8A1F" />
      </g>
      <g transform="translate(46 15) rotate(18)">
        <rect x="-9" y="-9" width="18" height="18" rx="3" fill="#F2A93B" stroke="#8A4E12" strokeWidth="2" />
        <path d="M-9 -4 H9 M-9 4 H9" stroke="#C47A22" strokeWidth="1.5" />
        <path d="M0 -6 L1.6 -2 L5.7 -1.9 L2.5 0.8 L3.5 4.9 L0 2.6 L-3.5 4.9 L-2.5 0.8 L-5.7 -1.9 L-1.6 -2 Z" fill="#FFFFFF" />
      </g>
    </svg>
  );
}
